module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-2.871847e6.jpg";